import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

  container: ({ marginTop }) => {
    return {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: marginTop,
    }
  },

  avatarIcon: {
    padding: '11px',
    // border: '1px #e5e5e5 solid',
    backgroundColor: '#fff',

    '& img': {
      maxHeight: '48px',
      objectFit: 'contain',
    }
  },

  clientAvatarIcon: ({ isOauthFailing }) => {
    return {
      marginLeft: isOauthFailing && '-8px',
    }
  },

  loadingIconStyling: ({ marginInBetween }) => {
    return {
      margin: `0px ${marginInBetween}`,
    }
  },

});

export default styles;
export const useStyles = makeStyles(styles);
